import { createAuthApi } from './auth/createAuthApi';
import { createOrdersApi } from './orders/createOrdersApi';
import type { Api } from './types/api';
import type { HttpClient } from './types/httpClient';
import { createUserApi } from './user/createUserApi';

/**
 * The backend API over the app's transport: `api.auth.login(…)`, `api.user.getProfile()`.
 *
 * @example
 * const api = createApi(httpClient);
 * const { user } = await api.user.getProfile();
 */
export function createApi(http: HttpClient): Api {
    return {
        auth: createAuthApi(http),
        user: createUserApi(http),
        orders: createOrdersApi(http),
    };
}
